var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop"},React.createElement("g",{"id":"General-Enquiry"},React.createElement("g",{"id":"Group-3"},React.createElement("path",{"id":"Fill-1","d":"M-209,8.87l-11,11-11-11a1.44,1.44,0,0,0-2,0,1.44,1.44,0,0,0,0,2.05l11,11-11,11a1.44,1.44,0,0,0,0,2,1.44,1.44,0,0,0,2,0l11-11,11,11a1.44,1.44,0,0,0,2,0,1.44,1.44,0,0,0,0-2l-11-11,11-11a1.44,1.44,0,0,0,0-2.05,1.44,1.44,0,0,0-2,0","transform":"translate(233.5 -8.44)","style":{"fillRule":"evenodd"}})))));
}

Close.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 27 27"};

module.exports = Close;

Close.default = Close;
